import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { verifySubscription } from "../lib/api";
import { Horse, CheckCircle, SpinnerGap } from "@phosphor-icons/react";

export default function SubscriptionSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    const check = async () => {
      try {
        const res = await verifySubscription(sessionId);
        if (res.status === "paid" || res.active) {
          setStatus("success");
          setTimeout(() => navigate("/"), 3000);
        } else {
          setTimeout(check, 2000);
        }
      } catch {
        setStatus("error");
      }
    };
    check();
  }, [sessionId, navigate]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center text-white">
      <div className="text-center max-w-md px-4">
        <Horse weight="fill" size={48} className="mx-auto text-[#E12B00] mb-4" />
        {status === "verifying" && (
          <>
            <SpinnerGap weight="bold" size={32} className="mx-auto text-[#D4AF37] animate-spin mb-3" />
            <h2 className="text-xl font-bold mb-2">Verifying your subscription...</h2>
            <p className="text-zinc-500 text-sm">Please wait while we confirm your payment</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle weight="fill" size={48} className="mx-auto text-[#008A27] mb-3" />
            <h2 className="text-xl font-bold mb-2">Subscription Active!</h2>
            <p className="text-zinc-400 text-sm">Welcome to Racing Form Guide. Redirecting to dashboard...</p>
          </>
        )}
        {status === "error" && (
          <>
            <h2 className="text-xl font-bold mb-2 text-[#E12B00]">Verification Failed</h2>
            <p className="text-zinc-400 text-sm mb-4">Please try logging in again or contact support.</p>
            <button onClick={() => navigate("/")} className="bg-[#E12B00] text-white px-6 py-2 font-mono text-sm">Go Home</button>
          </>
        )}
      </div>
    </div>
  );
}
